<template>
  <v-col class="left-side" cols="1" md="1">
    <v-btn class="btn-add-category" @click="init">
      <img v-if="!isEdit" src="@/assets/img/plus-icon.png" alt="icon">
      <slot></slot>
    </v-btn>
    <v-dialog v-model="dialog" max-width="620">
      <v-card class="modal">
        <div class="modal-head">
          <template v-if="!isEdit">
            {{ $t('Добавление') }}
          </template>
          <template v-else>
            {{ $t('Редактирование') }}
          </template>
          <v-btn color="modal-close" @click.native="dialog = false">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="tab-main">
            <v-form
              class="form-ru"
              ref="form"
              v-model="valid"
              lazy-validation
              enctype="multipart/form-data"
              @submit.prevent="createMapLayer"
            >
              <v-tabs
                background-color="white"
                left
                v-model="langMapLayerTab"
              >
                <v-tab>Русский</v-tab>
                <v-tab>Кыргызча</v-tab>
                <v-tab>English</v-tab>
                <v-tab-item v-for="tabItem in tabItems" :key="tabItem.name">
                  <div :class="{ 'form-label-copy': !tabItem.main }">
                    <v-row :class="{ invalid: $v.mapLayer.name.$error && tabItem.main }">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Наименование') }}: <span v-if="tabItem.main" class="asterix">*</span>
                          <fieldInfo :info="$t('Наименование')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <Copy
                          v-if="!tabItem.main"
                          :original="mapLayer[tabItem.nameMain]"
                          @copyText="copyText($event, tabItem.name)"
                        />
                        <v-text-field
                          v-model="mapLayer[tabItem.name]"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Описание') }}:
                          <fieldInfo :info="$t('Описание')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <Copy v-if="!tabItem.main" :original="mapLayer[tabItem.descriptionMain]"
                              @copyText="copyText($event, tabItem.description)"/>
                        <v-textarea
                          v-model="mapLayer[tabItem.description]"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main" :class="{ invalid: $v.mapLayer.file.$error && tabItem.main }">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Файл') }}: <span v-if="tabItem.main" class="asterix">*</span>
                          <fieldInfo :info="$t('Файл')"/>
                        </v-label>
                      </v-col>
                      <v-col v-if="tabItem.main" class="input-field">
                        <a v-if="file" :href="file" target="_blank">{{ $t('Файл')}}</a>
                        <v-file-input
                          required
                          dense
                          outlined
                          clearable
                          ref="file"
                          v-model="mapLayer.file"
                          v-on:change="handleFileUpload()"
                          :error="$v.mapLayer.file.$error && tabItem.main"
                        >
                        </v-file-input>
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Тип') }}:
                          <fieldInfo :info="$t('Тип')"/>
                        </v-label>
                      </v-col>
                      <v-col v-if="tabItem.main" class="input-field">
                        <v-select
                          v-model="mapLayer.type"
                          :items="types"
                          return-value
                          item-value="id"
                          item-text="transName"
                          dense
                          outlined
                          clearable
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Статус') }}: <fieldInfo :info="$t('Статус')"/>
                        </v-label>
                      </v-col>
                      <v-col v-if="tabItem.main" class="input-field">
                        <v-radio-group
                          v-model="mapLayer.isActive"
                          row
                        >
                          <v-radio
                            :label="$t('Активен')"
                            :value="true"
                          ></v-radio>
                          <v-radio
                            :label="$t('Не активен')"
                            :value="false"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
              </v-tabs>
              <div class="form-action">
                <button
                  class="btn btn-default blue"
                  type="submit"
                >
                  {{ $t('Сохранить') }}
                </button>
                <button
                  class="btn btn-default gray"
                  type="button"
                  @click="dialog = false"
                >
                  {{ $t('Отмена') }}
                </button>
              </div>
            </v-form>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import ooptMapLayer from '@/model/ooptMapLayer'
import { required } from 'vuelidate/lib/validators'
import fieldInfo from '@/components/app/fieldInfo'
import Copy from '@/components/oopt/Copy'

export default {
  components: {
    Copy,
    fieldInfo
  },
  props: {
    ooptId: Number,
    types: Array,
    id: Number,
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    langMapLayerTab: null,
    file: '',
    mapLayer: {
      id: null,
      name: null,
      nameKg: null,
      nameEn: null,
      description: null,
      descriptionEn: null,
      descriptionKg: null,
      isActive: false,
      type: null,
      file: null
    },
    rules: {
      mapLayer: {
        file: { required },
        name: { required }
      }
    },
    tabItems: [
      {
        main: true,
        name: 'name',
        description: 'description'
      },
      {
        main: false,
        nameMain: 'name',
        descriptionMain: 'description',
        name: 'nameKg',
        description: 'descriptionKg'
      },
      {
        main: false,
        nameMain: 'name',
        descriptionMain: 'description',
        name: 'nameEn',
        description: 'descriptionEn'
      }
    ],
    valid: true
  }),
  validations () {
    return this.rules
  },
  methods: {
    handleFileUpload () {
      this.file = ''

      if (this.mapLayer.file) {
        this.createFile(this.mapLayer.file)
      }
    },
    createFile (file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Создание/Редактирование карты слоя
    createMapLayer () {
      if (!this.validateForm()) return

      const formData = new FormData()

      formData.append('ooptMapLayer[uploadedFile]', this.mapLayer.file)
      formData.append('ooptMapLayer[name]', this.mapLayer.name)
      formData.append('ooptMapLayer[type]', this.mapLayer.type)
      if (this.mapLayer.nameKg) {
        formData.append('ooptMapLayer[nameKg]', this.mapLayer.nameKg)
      }
      if (this.mapLayer.nameEn) {
        formData.append('ooptMapLayer[nameEn]', this.mapLayer.nameEn)
      }
      if (this.mapLayer.description) {
        formData.append('ooptMapLayer[description]', this.mapLayer.description)
      }
      if (this.mapLayer.descriptionKg) {
        formData.append('ooptMapLayer[descriptionKg]', this.mapLayer.descriptionKg)
      }
      if (this.mapLayer.descriptionEn) {
        formData.append('ooptMapLayer[descriptionEn]', this.mapLayer.descriptionEn)
      }
      if (this.mapLayer.isActive !== false) {
        formData.append('ooptMapLayer[isActive]', this.mapLayer.isActive)
      }

      if (this.isEdit && this.id) {
        ooptMapLayer.edit(formData, this.id)
          .then((res) => {
            if (res.status === 200) {
              this.$noty.success(this.$i18n.t('Успешно обновлено'), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
              this.$parent.fetchData()
              this.dialog = false
            }
          })
          .catch((err) => {
            let msg = err.message
            if (err.response) {
              if (err.response.data.form) {
                msg = this.$i18n.t(err.response.data.form.message)
              } else if (err.response.data.message) {
                msg = this.$i18n.t(err.response.data.message)
              }
            }
            this.validateForm()
            this.$noty.error(msg, {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          })
      } else {
        ooptMapLayer.create(formData, this.ooptId)
          .then((res) => {
            if (res.status === 201) {
              this.$noty.success(this.$i18n.t('Успешно добавлено'), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
              this.$parent.fetchData()
              this.dialog = false
            }
          })
          .catch((err) => {
            let msg = err.message
            if (err.response) {
              if (err.response.data.form) {
                msg = this.$i18n.t(err.response.data.form.message)
              } else if (err.response.data.message) {
                msg = this.$i18n.t(err.response.data.message)
              }
            }
            this.validateForm()
            this.$noty.error(msg, {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          })
      }
    },
    init () {
      if (this.isEdit && this.id) {
        ooptMapLayer.getEdit(this.id)
          .then((res) => {
            this.mapLayer = res.data
            if (this.mapLayer.file) {
              this.file = process.env.VUE_APP_BACK_URL + this.mapLayer.file
            } else {
              this.mapLayer.file = 'null'
            }
            this.dialog = true
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.mapLayer = {
          id: null,
          name: null,
          nameKg: null,
          nameEn: null,
          description: null,
          descriptionEn: null,
          descriptionKg: null,
          type: null,
          isActive: false,
          file: null
        }
        this.file = ''
        this.$v.$reset()
        this.dialog = true
      }
    },
    // Копирование текста для мультиязычности
    copyText (title, refName) {
      this.mapLayer[refName] = title
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
          (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
          (document.body.scrollTop || document.documentElement.scrollTop) -
          90
      )
    }
  }
}
</script>

<style scoped>
  .v-input--radio-group {
    margin: 0;
    padding: 0;
  }
</style>
